import { useQuery } from '@tanstack/react-query';

import { fetchTermsofUse } from 'apis/hcp/users.api';
import { getSession } from 'utils/storage';

const transformResponse = (response: {
  data: { s3Url: string; versionId: string; versionReadByPortalUser: string };
}) => {
  return response.data;
};

const useFetchTermsOfUse = (language: string, region: string, isAuthenticated?: boolean) => {
  const {
    data: termsData,
    isPending,
    isFetching,
    error,
  } = useQuery({
    queryKey: ['terms', language, region],
    queryFn: ({ signal }) => fetchTermsofUse(language, region, signal),
    select: transformResponse,
    enabled: !!getSession() || !!isAuthenticated,
    refetchOnWindowFocus: true,
    retry: false,
  });

  return { termsData, isPending, error, isFetching };
};

export default useFetchTermsOfUse;
